import { flow } from "fp-ts/lib/function";

import { Scale } from "../../lens-stats/formatters";
import { roundWithScale, safeDivide } from "../math";
import { type AverageStatPair, type InsightsMetrics, type StatsItem } from "../models";

export const mapAverageStatValueOverTime =
    (averageStatPair: AverageStatPair) =>
    (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => {
        const valueOverTime = flow(
            ({ stat, lensPlays }: AverageStatPair) => safeDivide(stat, lensPlays),
            roundWithScale(Scale.h),
        )(averageStatPair);

        return {
            ...computedMetric,
            valueOverTime,
        };
    };

export const mapAverageStatValueOverTimeFormatted = (
    computedMetric: InsightsMetrics<StatsItem>,
): InsightsMetrics<StatsItem> => ({
    ...computedMetric,
    valueOverTimeFormatted:
        computedMetric.valueOverTime && computedMetric.valueOverTime > 0
            ? computedMetric.valueOverTime.toFixed(1)
            : "-",
});
